import * as React from "react";
import memoize from "memoize-one";
export class PolarScaleHandler extends React.Component {
    constructor() {
        super(...arguments);
        this.getDiff = memoize((range) => {
            let diff = range[1] - range[0];
            return Math.abs(diff);
        });
        this.getPolarExtend = memoize((ratio, extendDiff, currentExtend) => {
            let expand = (extendDiff * ratio - extendDiff) / 2;
            let polarExtend = [currentExtend[0] - expand, currentExtend[1] + expand];
            return polarExtend;
        });
    }
    render() {
        const { yScale, xScale } = this.props;
        let finalRatio;
        let polarExtend;
        if (this.props.showAsPolar) {
            let height = this.getDiff(yScale.range());
            let width = this.getDiff(xScale.range());
            let yExtend = this.getDiff(yScale.domain());
            let xExtend = this.getDiff(xScale.domain());
            let yRatio = height / yExtend;
            let xRatio = width / xExtend;
            if (yRatio > xRatio) {
                finalRatio = yRatio / xRatio;
                polarExtend = this.getPolarExtend(finalRatio, yExtend, yScale.domain());
                return this.props.render(yScale.copy().domain(polarExtend), xScale.copy());
            }
            else {
                let finalRatio = xRatio / yRatio;
                polarExtend = this.getPolarExtend(finalRatio, xExtend, xScale.domain());
                return this.props.render(yScale.copy(), xScale.copy().domain(polarExtend));
            }
        }
        return this.props.render(yScale, xScale);
    }
}
//# sourceMappingURL=PolarScaleHandler.js.map